import { DiscountNameplate, NameplateItem } from '@api/catalog';

import Picture from '@components/controls/future/Picture';

import { scale } from '@scripts/gds';
import { transformImageUrl } from '@scripts/helpers';

const Tags = ({ tags }: { tags?: (NameplateItem | DiscountNameplate)[] }) => (
    <div css={{ display: 'flex', gap: scale(1, true), flexDirection: 'column' }}>
        {tags
            ?.sort((a, b) => a.position - b.position)
            ?.map(
                (tag, index) =>
                    tag.image && (
                        <Picture
                            sources={[
                                {
                                    media: '',
                                    image: transformImageUrl(tag.image, scale(4), scale(4)),
                                },
                            ]}
                            alt={tag.name}
                            width={scale(4)}
                            height={scale(4)}
                            key={`${tag.id}-${index}`}
                        />
                    )
            )}
    </div>
);

export default Tags;
